// extracted by mini-css-extract-plugin
module.exports = {"clearIconContainer":"ClearInputIcon_clearIconContainer__SJWTP","icon":"ClearInputIcon_icon__m6i8c"};